export default __webpack_public_path__ + "static/media/trx.fb32a27b.png";